import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CountdownTimer } from './CountdownTimer';
import { Shield, Lock, Smartphone, Zap } from 'lucide-react';
export function FinalCta() {
  const [selected, setSelected] = useState<'standard' | 'pro'>('pro');
  const handleCheckout = () => {
    if (selected === 'standard') {
      window.location.href = 'https://pagos.recursosfitness.shop/cart/44055256498273:1';
    } else {
      window.location.href = 'https://pagos.recursosfitness.shop/cart/44055261446241:1';
    }
  };
  return <Section className="bg-dark text-white text-center" dark data-id="element-131">
      <div className="max-w-3xl mx-auto" data-id="element-132">
        <CountdownTimer data-id="element-133" />

        <div className="mt-4 md:mt-10 bg-[#0a0a0a] p-3 md:p-8 rounded-xl md:rounded-3xl shadow-2xl text-left" data-id="element-134">
          <div className="flex flex-col gap-2.5 md:gap-4" data-id="element-135">
            {/* Standard Option */}
            <div onClick={() => setSelected('standard')} className={`cursor-pointer border rounded-lg md:rounded-xl p-3 md:p-5 flex items-center gap-2.5 md:gap-4 transition-all ${selected === 'standard' ? 'border-primary bg-primary/10' : 'border-gray-700/50 bg-dark-light/50 hover:border-gray-600'}`} data-id="element-136">
              <div className="flex-shrink-0" data-id="element-137">
                <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${selected === 'standard' ? 'border-primary-light' : 'border-gray-600'}`} data-id="element-138">
                  {selected === 'standard' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-primary-light" data-id="element-139"></div>}
                </div>
              </div>

              <div className="flex-1 min-w-0" data-id="element-140">
                <div className="flex justify-between items-center" data-id="element-141">
                  <h3 className="text-white font-black text-xs md:text-lg uppercase leading-tight" data-id="element-142">
                    ⚽ MEGAPACK FÚTBOL RESUELTO
                  </h3>
                  <div className="text-right flex-shrink-0 ml-2" data-id="element-143">
                    <p className="text-gray-500 line-through text-[9px] md:text-sm font-medium" data-id="element-144">
                      $34.990
                    </p>
                    <p className="text-white font-black text-lg md:text-3xl leading-none" data-id="element-145">
                      $19.990
                    </p>
                  </div>
                </div>
                <p className="text-gray-500 text-[10px] md:text-sm mt-0.5" data-id="element-146">
                  6 Tomos + 6 Bonos
                </p>
              </div>
            </div>

            {/* PRO Option — visually highlighted */}
            <div onClick={() => setSelected('pro')} className={`cursor-pointer border-2 rounded-lg md:rounded-xl p-3 md:p-5 flex items-center gap-2.5 md:gap-4 transition-all relative overflow-hidden ${selected === 'pro' ? 'border-gold bg-gradient-to-br from-gold/10 via-dark-light to-gold/5 shadow-[0_0_25px_rgba(245,197,24,0.2)]' : 'border-gold/40 bg-dark-light/50 hover:border-gold/70'}`} data-id="element-147">
              <div className="absolute -top-8 -right-8 w-24 h-24 bg-gold/15 rounded-full blur-2xl pointer-events-none" data-id="element-148"></div>

              <div className="flex-shrink-0 relative z-10" data-id="element-149">
                <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${selected === 'pro' ? 'border-gold' : 'border-gold/50'}`} data-id="element-150">
                  {selected === 'pro' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-gold" data-id="element-151"></div>}
                </div>
              </div>

              <div className="flex-1 min-w-0 relative z-10" data-id="element-152">
                <div className="flex justify-between items-start" data-id="element-153">
                  <div className="pr-2" data-id="element-154">
                    <h3 className="text-white font-black text-xs md:text-lg uppercase leading-tight" data-id="element-155">
                      🏆 MEGAPACK + TÁCTICO PRO™
                    </h3>
                    <div className="flex gap-1.5 mt-1" data-id="element-156">
                      <span className="bg-gold text-black text-[8px] md:text-xs font-black px-1.5 md:px-2 py-px md:py-0.5 rounded" data-id="element-157">
                        ⭐ MÁS ELEGIDO
                      </span>
                      <span className="bg-gold/15 text-gold border border-gold/30 text-[8px] md:text-xs font-bold px-1.5 md:px-2 py-px md:py-0.5 rounded" data-id="element-158">
                        AHORRÁS $16.000
                      </span>
                    </div>
                  </div>
                  <div className="text-right flex-shrink-0 ml-2" data-id="element-159">
                    <p className="text-gray-500 line-through text-[9px] md:text-sm font-medium" data-id="element-160">
                      $43.990
                    </p>
                    <p className="text-gold font-black text-lg md:text-3xl leading-none" data-id="element-161">
                      $27.990
                    </p>
                  </div>
                </div>
                <p className="text-gray-400 text-[10px] md:text-sm mt-1" data-id="element-162">
                  6 Tomos + 6 Bonos + Fútbol Táctico Pro™
                </p>
              </div>
            </div>
          </div>

          <Button variant="gold" size="lg" fullWidth onClick={handleCheckout} className="mt-4 md:mt-6 py-3 md:py-4 text-sm md:text-2xl font-black uppercase shadow-lg shadow-gold/20" data-id="element-163">
            SÍ, QUIERO{' '}
            {selected === 'pro' ? 'EL MEGAPACK + PRO' : 'MI MEGAPACK'} →
          </Button>

          <p className="text-center text-gray-500 italic text-[10px] md:text-sm mt-2 md:mt-4" data-id="element-164">
            La opción más elegida por instructores que quieren dirigir con
            criterio profesional
          </p>

          <div className="mt-3 md:mt-6 border border-gray-800 rounded-lg md:rounded-xl py-2.5 px-3 md:p-4 bg-dark-light/50 flex flex-wrap justify-center gap-3 md:gap-8 text-[10px] md:text-sm text-gray-400 font-medium" data-id="element-165">
            <div className="flex items-center" data-id="element-166">
              <Lock className="w-3 h-3 md:w-4 md:h-4 mr-1 text-primary-light" data-id="element-167" />{' '}
              Pago seguro
            </div>
            <div className="flex items-center" data-id="element-168">
              <Zap className="w-3 h-3 md:w-4 md:h-4 mr-1 text-primary-light" data-id="element-169" />{' '}
              Acceso en 5 min
            </div>
            <div className="flex items-center" data-id="element-170">
              <Shield className="w-3 h-3 md:w-4 md:h-4 mr-1 text-primary-light" data-id="element-171" />{' '}
              Garantía 7 días
            </div>
            <div className="flex items-center" data-id="element-172">
              <Smartphone className="w-3 h-3 md:w-4 md:h-4 mr-1 text-primary-light" data-id="element-173" />{' '}
              Mercado Pago
            </div>
          </div>
        </div>
      </div>
    </Section>;
}